'use client'

import { useGoogleAnalytics } from '@/utils/hooks/useGoogleAnalitics'
import React, { useEffect, useRef, useState } from 'react'
import { FaBell } from 'react-icons/fa'
import { NotificationBadge, NotificationsOverlay } from '../uiComponents'

export const NotificationButton = () => {
	const [notReadCount, setNotReadCount] = useState<number>(0)
	const [isOverlayOpen, setIsOverlayOpen] = useState<boolean>(false)
	const [hasNotifications, setHasNotifications] = useState<boolean>(false)

	const overlayRef = useRef<HTMLDivElement>(null)
	const { pushLabelClickedEvent } = useGoogleAnalytics()

	const toggleNotificationsOverlay = (e: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>) => {
		e.stopPropagation()
		setIsOverlayOpen(!isOverlayOpen)
	}

	const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (event.key === 'Enter') {
			toggleNotificationsOverlay(event)
			return
		}

		if (event.key === 'Escape') {
			setIsOverlayOpen(false)
			return
		}
	}

	const handleClickOutside = (event: MouseEvent) => {
		if (overlayRef.current && !overlayRef.current.contains(event.target as Node)) {
			setIsOverlayOpen(false)
		}
	}

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside)
		return () => document.removeEventListener('mousedown', handleClickOutside)
	}, [])

	return (
		<div
			className="md:relative flex justify-center py-4 px-2 cursor-pointer"
			ref={overlayRef}
			tabIndex={0}
			role="button"
			aria-pressed={isOverlayOpen}
			onClick={(e) => {
				toggleNotificationsOverlay(e)
				pushLabelClickedEvent({ label_clicked: 'Bell', event: 'privatemenu', eventName: 'private_right_menu' })
			}}
			onKeyDown={handleKeyDown}
		>
			{hasNotifications && (
				<div className="relative">
					{notReadCount > 0 && (
						<NotificationBadge position="over" color="primary">
							{notReadCount}
						</NotificationBadge>
					)}
					<FaBell />
				</div>
			)}
			<NotificationsOverlay open={isOverlayOpen} notReadCount={setNotReadCount} isReady={setHasNotifications} />
		</div>
	)
}
